import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { getMobileApkUrl, MOBILE_APK_FILE_NAME } from '../../core/utils/mobile-app';

@Component({
  selector: 'app-mobile-app-link',
  templateUrl: './mobile-app-link.component.html',
  styleUrls: ['./mobile-app-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MobileAppLinkComponent implements OnInit, OnDestroy {

  @Input() label = 'Mobile App';
  @Input() showHint = false;
  @Input() compact = false;

  readonly apkUrl = getMobileApkUrl();
  readonly fileName = MOBILE_APK_FILE_NAME;
  apkBuiltAt = '';

  get compactTooltip(): string {
    return this.apkBuiltAt ? `${this.label} · Stand: ${this.apkBuiltAt}` : this.label;
  }

  private _abort?: AbortController;

  constructor(private readonly _cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._abort = new AbortController();
    fetch(this.apkUrl, { method: 'HEAD', signal: this._abort.signal })
      .then(res => {
        if (!res.ok) {
          return;
        }
        const lastModified = res.headers.get('Last-Modified');
        if (!lastModified) {
          return;
        }
        this.apkBuiltAt = dayjs(lastModified).format('DD.MM.YYYY');
        this._cdr.markForCheck();
      })
      .catch(() => {});
  }

  ngOnDestroy(): void {
    this._abort?.abort();
  }
}
